module.exports = __webpack_public_path__ + "img/1920_stores_img6.354feb59.png";